import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromLayout from '..';
import { LayoutActions } from '..';
import {
  selectIsMobile,
  selectIsRightPanelMaximized,
  selectIsRightPanelOpened,
  selectIsSidebarOpened,
} from '../store/layout.selectors';
import {
  HeaderDesktopResponsive,
  HeaderStyle,
} from './header.desktop.responsive';
import { HeaderMobileResponsive } from './header.mobile.responsive';

@Component({
  selector: 'dmcom-header',
  imports: [HeaderDesktopResponsive, HeaderMobileResponsive],
  template: `
    @if (isMobile()) {
      <dmcom-header-mobile
        [isSidebarOpened]="isSidebarOpened()"
        (toggleSidebar)="onToggleSidebar()"
      />
    } @else {
      <dmcom-header-desktop
        [headerStyle]="headerStyle()"
        [isSidebarOpened]="isSidebarOpened()"
        [isRightPanelOpened]="isRightPanelOpened()"
        [isRightPanelMaximized]="isRightPanelMaximized()"
        (toggleSidebar)="onToggleSidebar()"
      />
    }
  `,
  styles: [``],
})
export class HeaderComponent {
  private readonly layoutStore = inject<Store<fromLayout.LayoutState>>(Store);
  public readonly router = inject<Router>(Router);
  public readonly headerStyle = input<HeaderStyle>(HeaderStyle.transparent);

  public readonly isMobile = toSignal(this.layoutStore.select(selectIsMobile));

  public readonly isSidebarOpened = this.layoutStore.selectSignal(
    selectIsSidebarOpened,
  );
  public readonly isRightPanelOpened = this.layoutStore.selectSignal(
    selectIsRightPanelOpened,
  );
  public readonly isRightPanelMaximized = this.layoutStore.selectSignal(
    selectIsRightPanelMaximized,
  );

  onToggleSidebar() {
    this.layoutStore.dispatch(
      LayoutActions.setSidebarOpened({
        isOpened: !this.isSidebarOpened(),
      }),
    );
  }
}
